import React from 'react'
import SVG from 'react-svg-inline'

const Clockbeats = () =>
  <div>
    <section className="container full">
      <div className="col-12-of-12">
        {/* <img src={require('img/jomo/phone-in-hand.jpg')} alt="JOMO Feature" /> */}
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
        Have you ever imagined a place where you can share your feelings, your talent, your ideas, 
        showing your competence and finding contacts for the finalization of your projects? <br/>
        </blockquote>
        <br/>
        <blockquote>
        <b className="brand-color">Clockbeats is the result of a wide dream: building a home with no walls, no barriers, no prejudices. The home of artists.</b>
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <iframe src="https://player.vimeo.com/video/148559361" width="100%" height="720" frameBorder="0" allowFullScreen></iframe>
        <p><a href="https://vimeo.com/148559361">Clockbeats - Break The Sound Barriers</a> from <a href="https://vimeo.com/user46244838">Clockbeats</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
      </div>
    </section>
    <section className="container full split-view m-tb-m">
      <aside className="content">
        <h3>What is Clockbeats?</h3>
        <h4 style={{ marginBottom: "20px"}}>
          Clockbeats is the result of a wide dream: building a home with no walls, no barriers, no prejudices. The home of Music.
        </h4>
        <a href="https://www.clockbeats.com/get-started" target="_blank" rel="noopener noreferrer" className="btn dark">Learn More</a>
      </aside>
      <aside>
        {<img src={require('img/clockbeats/clb_drawning.jpg')} alt="clockbeats artwork" />}
      </aside>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote className="brand-color">
        A single arrow can easily be broken, a bundle of them can go for a breakthrough.
        </blockquote>
      </div>
    </section>
    <section className="container full split-view m-tb-m">
    <aside className="content">
      <h3>OUR MISSION</h3>
      <h4>
        We deeply trust in the educative power of music and in the importance of collaboration among individuals. <br/>
        Nowadays Music Industry needs a deep improvement in terms of Supply & Demand Market, Collaboration & Help among professionals, 
        Legal Protection and, more generally, we believe it’s time to open borders to different kinds of music, supporting every kind of genre.
      </h4>
    </aside>
    <aside>
      {<img src={require('img/clockbeats/cb_world_map.jpg')} alt="clockbeats world map" />}
    </aside>
  </section>
  </div>

export default Clockbeats



// WEBPACK FOOTER //
// src/javascripts/clients/Clockbeats.js